import React, { forwardRef, useEffect, useState } from "react";
import "./testimonial.css";
import { useTranslation } from "react-i18next";
import cookies from "js-cookie";
import { Link } from "react-router-dom";

const Testimonial = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const [language, setLanguage] = useState(cookies.get("i18next") || "en");

  const [trustboxConfig, setTrustboxConfig] = useState({
    website: "",
    trustboxlang: "",
    trustboxImages: [],
  });

  useEffect(() => {
    // Set trustbox data based on language
    if (language === "en") {
      setTrustboxConfig({
        website: "https://www.trustpilot.com/review/www.unlockriver.com",
        trustboxlang: "en-US",
        trustboxImages: [
          { name: "en1.jpg" },
          { name: "en2.jpg" },
          { name: "en3.jpg" },
          { name: "en4.jpg" },
        ],
      });
    } else {
      setTrustboxConfig({
        website: "https://es.trustpilot.com/review/www.unlockriver.com",
        trustboxlang: "es-ES",
        trustboxImages: [
          { name: "es1.jpg" },
          { name: "es2.jpg" },
          { name: "es3.jpg" },
          { name: "es4.jpg" },
        ],
      });
    }
  }, [language]);

  useEffect(() => {
    // Listen to language changes
    const currentLang = cookies.get("i18next");
    if (currentLang && currentLang !== language) {
      setLanguage(currentLang);
    }
  }, [language]);

  const images = trustboxConfig.trustboxImages.map((e, index) => (
    <div key={index} className="testimonial-item bg-white rounded-4">
      <img
        className="img-fluid rounded-4"
        loading="lazy"
        src={`/images/trustbox/${e.name}`}
        alt=""
      />
    </div>
  ));

  return (
    <div ref={ref}>
      <section className="testimonial py-md-5 py-2">
        <div className="container">
          <h2 className="display-5 text-center">
            {t("TestH11")}{" "}
            <span className="fw-bold text-dark">{t("TestH12")}</span>{" "}
            {t("TestH13")}{" "}
            <span className="fw-bold text-dark">{t("TestH14")}</span>
          </h2>
          <h2 className="text-center display-6">{t("TestH15")}</h2>

          <div className="row mt-5 mx-md-0 mx-2 px-md-5 justify-content-center">
            <div className="col-md-12 col-lg-3 trustpilot rounded-4 d-flex flex-column justify-content-center">
              <div>
                <img loading="lazy" src="/images/trustpilot-logo.png" alt="trustpilot-logo" />
                <div
                  className="trustpilot-widget"
                  data-locale={`${trustboxConfig.trustboxlang}`}
                  data-template-id="5419b6ffb0d04a076446a9af"
                  data-businessunit-id="544819a600006400057b1620"
                  data-style-height="40px"
                  data-style-width="100%"
                  data-theme="dark"
                >
                  <Link to={trustboxConfig.website} target="_blank" rel="noopener">
                    Trustpilot
                  </Link>
                </div>
                <Link className="btn btn-outline-light mt-4 px-3 py-3" to={trustboxConfig.website}>
                  {t("TestB1")}
                </Link>
              </div>
            </div>

            <div className="col-md-12 col-lg-8 d-flex px-0 px-md-3 flex-wrap gap-3 pt-2 py-0 pt-md-4 pt-lg-0">
              {images}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
});

export default Testimonial;
